export const createBrowserLogger = (service) => {
    const isProd = typeof process !== 'undefined' && process.env.NODE_ENV === 'production';
    return {
        info: (obj, msg) => console.log(`[${service}]`, msg, obj),
        warn: (obj, msg) => console.warn(`[${service}]`, msg, obj),
        error: (obj, msg) => console.error(`[${service}]`, msg, obj),
        debug: (obj, msg) => {
            if (!isProd) {
                console.debug(`[${service}]`, msg, obj);
            }
        },
    };
};
